import { Action, createReducer, on } from '@ngrx/store';
import * as MessageHubActions from '../../../../state/actions/message-hub.actions';
import { CentralLobbyViewGridData } from '../../shared/models/central-lobby-response.model';
import * as LobbyCentralViewAPIActions from '../actions/lobby-central-views.actions';

export interface LobbyCentralLobbyViewState {
    locationId: number[] | null;
    isLocationChanged: boolean;
    searchText: string;
    isInitialLoading: boolean;
    data: CentralLobbyViewGridData;
    IsSpanishSpeakerChange: boolean
}

const initialLobbyCentralLobbyViewState: LobbyCentralLobbyViewState = {
    locationId: null,
    isLocationChanged: false,
    searchText: '',
    data: { totalRowCount: 0, pageSize: 0, currentPageNumber: 0, data: [], numberOfPages: 0 },
    isInitialLoading: true,
    IsSpanishSpeakerChange: false

};

const reducer = createReducer<LobbyCentralLobbyViewState>(
    initialLobbyCentralLobbyViewState,
    on(MessageHubActions.receivedCentralLobbyStatusGridData, (LobbyCentralLobbyGridState, action): LobbyCentralLobbyViewState => (
        {
            ...LobbyCentralLobbyGridState,
            data: action.messageData ? JSON.parse(action.messageData) : {}
        }
    )),
    on(LobbyCentralViewAPIActions.searchTextChange, (LobbyCentralLobbyGridState, action): LobbyCentralLobbyViewState => (
        {
            ...LobbyCentralLobbyGridState,
            searchText: action.searchText
        }
    )),
    on(LobbyCentralViewAPIActions.centralLobbyIsSpanishSpeakerChange, (LobbyCentralLobbyGridState, action): LobbyCentralLobbyViewState => (
        {
            ...LobbyCentralLobbyGridState,
            IsSpanishSpeakerChange: action.IsSpanishSpeaker
        }
    ))
);

export function lobbyCentralLobbyViewReducer(state: LobbyCentralLobbyViewState | undefined, action: Action) {
    return reducer(state, action);
}
